import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CardBenefit as SimbaCardBenefit,
  SanityCardBenefitVariant,
  type CardBenefitVariantInput,
} from '@naf-simba/sections-cards';
import { MembershipBenefitHighlightLinkType } from '../../../../types/MembershipBenefitHighlightLinkType';
import { useCloudinary } from '../../hooks/Cloudinary/useCloudinary';
import { useToggleFavoriteBenefit } from '../../hooks/useToggleFavoriteBenefit';
import { CloudinaryImageType } from '../../../../types/CloudinaryImageType';
import { useDocumentUrlWithNode } from '../../hooks/Documents/useDocumentUrl';
import { DocumentTypeLabel } from '../../../../types/testType';

export interface CardBenefitProps {
  id?: string;
  title?: string;
  description?: string;
  image?: CloudinaryImageType;
  // We are changing the layout of big variant, and body will not be used at the moment.
  // body?: SanityBlock[];
  link?: MembershipBenefitHighlightLinkType;
  variant?: string;
}

export const CardBenefit = ({ id, title, description, image, link, variant }: CardBenefitProps) => {
  const navigate = useNavigate();
  const { getProcessedImage } = useCloudinary();
  const itemImage = getProcessedImage(image?.publicId || image?.public_id, {
    height: variant === SanityCardBenefitVariant.Large ? 183 : 100,
  });

  const { data } = link || {};
  const { queryParams } = data || {};
  const url = useDocumentUrlWithNode(data);

  const queryString = queryParams?.length
    ? `?${queryParams.map((param) => `${param.key}=${encodeURIComponent(param.value)}`).join('&')}`
    : '';

  const href = `${url}${queryString}`;

  // The highlight can link to a benefit or a category; favoriting only applies to an actual benefit,
  // identified by the reference's own id/slug (not this highlight block's id).
  const canFavorite = data?.type === DocumentTypeLabel.nafMembershipBenefit && !!data?.id;
  const { isFavorite, toggleFavorite } = useToggleFavoriteBenefit(
    canFavorite ? data?.id : undefined,
    canFavorite ? data?.slug : undefined,
    undefined,
    undefined,
    title,
  );

  return (
    <SimbaCardBenefit
      key={id}
      title={title}
      description={description}
      variant={variant as CardBenefitVariantInput}
      onClick={() => navigate(href)}
      image={itemImage ? { src: itemImage.toURL(), alt: image?.altText || '' } : undefined}
      link={link?.data ? { href, text: link.title, ariaLabel: link.title } : undefined}
      isFavorite={canFavorite ? isFavorite : undefined}
      favoriteAriaLabel={isFavorite ? 'Fjern fra favoritter' : 'Legg til i favoritter'}
      onFavoriteClick={canFavorite ? toggleFavorite : undefined}
    />
  );
};
